// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-top-bar[data-v-16645bf2] {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n.campaign-select[data-v-16645bf2] {\n  min-width: 500px;\n  width: 500px;\n}\n.campaign-select[data-v-16645bf2]  .el-input__inner {\n  font-size: 20px;\n  font-weight: 600;\n  padding-top: 10px;\n  padding-bottom: 12px;\n  height: 45px;\n}\n.campaign-select-wrapper[data-v-16645bf2] {\n  margin-top: 0;\n}", ""]);
// Exports
module.exports = exports;
